import classNames from "classnames";
import { sanitizeHtml } from "../../../functions/sanitizeHtml";
import { taskProgress, toggleTask } from "../../../functions/tasks";
import { useRef, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useDrag, useDrop } from "react-dnd";
import * as PropTypes from "prop-types";

import { getEventById, setOrder, swapEventsOrders, updateEvent } from "../../../store/events";
import { orderEventAPI, swapEventsOrder, updateEventAPI } from "../../../api/eventAPI";
import { DraggableTypes } from "../../utility/DraggableTypes";
import { EventIcon } from "../../utility/EventIcon";
import { setEventsToDelete } from "../../../store/settings";
import 'dayjs/locale/ru';
import "./EventDetail.scss";
import dayjs from "dayjs";
import Grid from "../GridLayout/Grid";


function EventDetail({ id, edit }) {
    const dispatch = useDispatch();
    const ref = useRef(null);
    const [isDetailed, setIsDetailed] = useState(false);

    const event = useSelector(state => getEventById(state, id));
    const filter = useSelector(state => state.settings.filter);
    const icon = EventIcon({ iconName: event.icon });
    const eventDeletion = useSelector(state => state.settings.eventDeletion);
    const eventsToDelete = useSelector(state => state.settings.eventsToDelete);
    const [isEventCheckedForDeletion, setEventCheckedForDeletion] = useState(eventsToDelete.includes(event.id));

    useEffect(() => {
        if (ref && ref.current) {
            ref.current.addEventListener("wheel", scrollEvent)
            return function cleanup() {
                const copyEventsRef = { ...ref };
                if (copyEventsRef && copyEventsRef.current)
                    copyEventsRef.current.removeEventListener("wheel", scrollEvent)
            }
        }
    });

    if (filter.categories.length > 0 && !filter.categories.includes(event.category)) return (<></>);

    const scrollEvent = (e) => {
        e.stopPropagation();
    }

    const handleBtn = (id) => {
        edit(id);
    }


    const showButton = () => {
        setIsDetailed(true)
    }
    const hideButton = () => {
        setIsDetailed(false);
    }

    // In its own colours, whatever colour the title is.
    const getDescription = () => event.description.replace(/\n/g, "<br/>");
    // Ticks a checklist item of the description right here, without opening the form. Like other edits, the
    // box changes once the server has saved it.
    const tickTask = (e) => {
        const box = e.target.closest('input[type="checkbox"]');
        if (!box) return;
        e.preventDefault();
        const boxes = [...e.currentTarget.querySelectorAll('li[data-type="taskItem"] > label > input[type="checkbox"]')];
        const description = toggleTask(event.description, boxes.indexOf(box));
        updateEventAPI({ ...event, description })
            .then(() => dispatch(updateEvent({ ...event, description })))
            .catch(err => console.log(err));
    };

    const tasks = taskProgress(event.description);

    const setEventToDelete = (e, value) => {
        e.stopPropagation();
        dispatch(setEventsToDelete(value))
        setEventCheckedForDeletion(e.target.checked)
    }

    return <div ref={ref}
        className={classNames({
            "day-layout-event": true,
            "day-layout-event_detail": isDetailed && (event.description.length !== 0),
            "day-layout-event_no-description": event.description?.length === 0,
        })}
        onMouseOver={(e) => showButton()}
        onMouseOut={(e) => hideButton()}
        style={{ backgroundColor: event.color, order: event.order, width: '100%', height: '100%' }}
    >
        <div
            className="day-layout-event-short"

            style={{ backgroundColor: event.color }}
        >
            <p className="title" dangerouslySetInnerHTML={{ __html: sanitizeHtml(event.title) }} />
            {tasks && <span className="tasks-progress" title="Выполнено задач">☑ {tasks.done}/{tasks.total}</span>}
            {icon.src &&
                <img className="event-icon" src={icon.src} alt="event icon" />}
            <i className="icon-triangle" />
            {eventDeletion &&
                <input type='checkbox' className="day-layout-checkbox" checked={isEventCheckedForDeletion} onClick={(e) => { setEventToDelete(e, event.id) }} />
            }
        </div>
        {
            event.description && <div
                className="day-layout-event-detail"

                style={{ backgroundColor: event.color }}
            >

                <p className="title" dangerouslySetInnerHTML={{ __html: sanitizeHtml(event.title) }} />
                <div className="desc" onClick={tickTask} dangerouslySetInnerHTML={{ __html: sanitizeHtml(getDescription()) }} />
                <i className="icon-triangle" />
            </div>
        }

        <div className={classNames({
            "day-layout-event__btn": true,
            "day-layout-event__btn_active": isDetailed,
        })}>
            <button className="btn" style={{ backgroundColor: event.color }} onClick={(e) => { handleBtn(event.id); }}><i className="icon-edit" /></button>
        </div>

    </div >;
}

EventDetail.propTypes = {
    event: PropTypes.any,
    onClick: PropTypes.func,
    onClick1: PropTypes.func
};

export { EventDetail };    